"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LockOpen = function LockOpen(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("path", {
    d: "M17.1852 10.4626C17.1866 10.4474 17.1876 10.4321 17.1876 10.4166C17.1871 10.278 17.1318 10.1452 17.0338 10.0472C16.9358 9.9492 16.803 9.89393 16.6644 9.89344C16.6489 9.89344 16.6336 9.89442 16.6184 9.89575H9.89588V7.29159C9.89588 6.60092 10.1703 5.93854 10.6586 5.45016C11.147 4.96179 11.8094 4.68742 12.5001 4.68742C13.1907 4.68742 13.8531 4.96179 14.3415 5.45016C14.8299 5.93854 15.1042 6.60092 15.1042 7.29159C15.1042 7.42972 15.1591 7.5622 15.2568 7.65987C15.3544 7.75755 15.4869 7.81242 15.6251 7.81242C15.7632 7.81242 15.8957 7.75755 15.9933 7.65987C16.091 7.5622 16.1459 7.42972 16.1459 7.29159C16.1459 6.32465 15.7618 5.39732 15.078 4.71359C14.3943 4.02987 13.467 3.64575 12.5001 3.64575C11.5331 3.64575 10.6058 4.02987 9.92206 4.71359C9.23833 5.39732 8.85422 6.32465 8.85422 7.29159V9.89575H8.37708C8.36189 9.89442 8.34661 9.89344 8.33107 9.89344C8.19247 9.89393 8.05968 9.9492 7.96168 10.0472C7.86367 10.1452 7.80839 10.278 7.80789 10.4166C7.80789 10.4321 7.80891 10.4474 7.81024 10.4626V18.7039C7.80891 18.7191 7.80789 18.7344 7.80789 18.7499C7.80839 18.8885 7.86367 19.0213 7.96168 19.1193C8.05968 19.2173 8.19247 19.2726 8.33107 19.2731C8.34661 19.2731 8.36189 19.2721 8.37708 19.2708H16.6184C16.6336 19.2721 16.6489 19.2731 16.6644 19.2731C16.803 19.2726 16.9358 19.2173 17.0338 19.1193C17.1318 19.0213 17.1871 18.8885 17.1876 18.7499C17.1876 18.7344 17.1866 18.7191 17.1852 18.7039V10.4626ZM8.8519 10.9374H16.1436V18.2291H8.8519V10.9374Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12.5 13.0208C12.3619 13.0208 12.2294 13.0756 12.1317 13.1733C12.0341 13.271 11.9792 13.4035 11.9792 13.5416V15.6249C11.9792 15.7631 12.0341 15.8955 12.1317 15.9932C12.2294 16.0909 12.3619 16.1458 12.5 16.1458C12.6382 16.1458 12.7706 16.0909 12.8683 15.9932C12.966 15.8955 13.0209 15.7631 13.0209 15.6249V13.5416C13.0209 13.4035 12.966 13.271 12.8683 13.1733C12.7706 13.0756 12.6382 13.0208 12.5 13.0208Z",
    fill: props.foregroundColor
  }));
};

LockOpen.defaultProps = {
  altText: "LockOpen",
  foregroundColor: "#2D5AB4"
};
LockOpen.propTypes = {
  altText: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = LockOpen;
exports.default = _default;